import './period-picker.scss';

import { DatePicker } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

import { API_DATE_FORMAT, DATE_FORMAT } from '@/shared/constants';

export type TPeriodValue = [string, string] | undefined;

interface IProps {
  id?: string;
  /** Период строками `YYYY-MM-DD` — так он хранится в адресе и уходит в запрос. */
  value?: TPeriodValue;
  onChange: (value: TPeriodValue) => void;
  onBlur?: () => void;
  disabledDate?: (date: Dayjs) => boolean;
  status?: 'error' | 'warning';
}

/**
 * Выбор периода на antd `RangePicker`: показывает даты как `ДД.ММ.ГГГГ`, а наружу
 * отдаёт строки `YYYY-MM-DD` — в фильтрах списков период пишется в адрес строкой.
 * Неполный период (одна граница) считается пустым.
 */
const PeriodPicker: React.FC<IProps> = ({
  id,
  value,
  onChange,
  onBlur,
  disabledDate,
  status
}) => (
  <DatePicker.RangePicker
    id={id}
    className="period-picker"
    format={DATE_FORMAT}
    value={value ? [dayjs(value[0]), dayjs(value[1])] : null}
    onChange={(dates) => {
      const [from, to] = dates ?? [];
      onChange(
        from && to
          ? [from.format(API_DATE_FORMAT), to.format(API_DATE_FORMAT)]
          : undefined
      );
    }}
    onBlur={onBlur}
    disabledDate={disabledDate}
    status={status}
  />
);

export default PeriodPicker;
